/* eslint-disable import/prefer-default-export */
import { styled } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export const AutocompleteStyled = styled(Autocomplete)({
  '& .MuiAutocomplete-tag': {
    height: 22,
    border: '1px solid #f4f4f5',
    borderRadius: 5,
    position: 'relative',
    margin: '0 4px 0 0 !important',
    maxWidth: 100,
  },
  '& .MuiAutocomplete-tag .MuiChip-label': {
    padding: '0 4px !important',
  },
  '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
    width: 13,
    height: 13,
    position: 'absolute',
    top: 0,
    right: 5,
    transform: 'translate(65%, -20%)',
    color: '#0d0d0d',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  '& .MuiInputBase-root': {
    display: 'flex',
    gap: 2,
  },
  '& .MuiAutocomplete-paper': {
    padding: '2px !important',
  },
  '& .MuiAutocomplete-option': {
    marginTop: '2px !important',
  },
}) as typeof Autocomplete;
